import observer from './intersection-observer-component';
import createLoaderStub from './create-loader-stub';

/**
* Данная фнкция возвращает промис на мобильных устройствах с учетом view-port,
* что дает возможность монтировать компоненты не сразу после загрузки, а только после домотки до определенного блока (с запасом см. observer)
* @param {String} $el
* @return Promise
*/

const mobileMountingComponent = ($el) => new Promise((resolve) => {
  // добавим лоадер загрушку для компонента, когда он будет готов разметка заменится разметкой view
  createLoaderStub($el);
  observer(document.querySelector($el))
    .then(() => {
      resolve();
    });
});

export default mobileMountingComponent;
